import React from 'react';
import Button from './Button';

// Educational content for each feature
const featureEducation = {
  bridgebot: {
    title: "🤖 BridgeBot Chat",
    benefit: "Your 24/7 AI mental wellness companion answering your mood and stress needs.",
    research: {
      stat: "73%",
      detail: "of teens prefer AI mental health support initially due to reduced stigma",
      backup: "AI detects concerning language 85% faster than traditional screening"
    }
  },
  quests: {
    title: "🎯 Daily Quests",
    benefit: "Daily micro-challenges reinforce healthy mental habits through game mechanics.",
    research: {
      stat: "67%",
      detail: "increase in completion rates with 3-5 minute wellness quests",
      backup: "Dopamine reward systems in teens respond strongly to achievements"
    }
  },
  biofeedback: {
    title: "🧘 Biofeedback Session",
    benefit: "Guided breathing sessions to regulate stress via heart rate variability training.",
    research: {
      stat: "32%",
      detail: "reduction in cortisol through HRV training in adolescents",
      backup: "Aids prefrontal development which continues until age 25"
    }
  },
  nutrition: {
    title: "📸 FoodScan Tracker",
    benefit: "Quick nutritional feedback supports brain health and mood regulation.",
    research: {
      stat: "67%",
      detail: "improvement in nutritional awareness with visual food logging",
      backup: "Omega-3 fatty acids bolster prefrontal cortex development"
    }
  },
  sleep: {
    title: "😴 SleepSense Tracker",
    benefit: "Monitor and optimize your sleep to reduce depression and anxiety risk.",
    research: {
      stat: "38%",
      detail: "increased depression risk with chronic sleep deprivation in teens",
      backup: "Sleep deprivation raises anxiety risk by 55% in adolescents"
    }
  },
  social: {
    title: "🌐 Social Browser",
    benefit: "Curated social feeds minimize harmful comparisons and addictive behaviors.",
    research: {
      stat: "41%",
      detail: "reduction in negative effects with timed social media breaks",
      backup: "Social comparison theory shows upward comparisons increase teen depression"
    }
  },
  focus: {
    title: "🔮 Focus Bubble",
    benefit: "Scheduled device breaks restore dopamine sensitivity and support offline skills.",
    research: {
      stat: "20 min",
      detail: "optimal detox duration to restore baseline dopamine sensitivity",
      backup: "Improves neuroplasticity for stress resilience"
    }
  },
  peer: {
    title: "🤝 Peer Support Network",
    benefit: "Connect safely with peers and mentors to combat isolation.",
    research: {
      stat: "50%",
      detail: "reduction in suicide risk with structured peer interactions",
      backup: "Peer support is 3x more effective than adult guidance for teens"
    }
  }
};

function EducationalBanner({ feature, onDismiss }) {
  const featureInfo = featureEducation[feature];
  
  if (!featureInfo) return null;

  return (
    <div style={{
      backgroundColor: '#e3f2fd',
      border: '1px solid #bbdefb',
      borderRadius: '12px',
      padding: '20px',
      marginBottom: '20px',
      animation: 'fadeIn 0.4s ease-out'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          margin: 0,
          fontSize: '18px',
          fontWeight: '600'
        }}>
          {featureInfo.title}
        </h3>
        <button 
          onClick={onDismiss}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            lineHeight: 1,
            color: '#94a3b8',
            padding: '4px',
            borderRadius: '4px'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#d1e7fe'}
          onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
        >
          ×
        </button>
      </div>
      
      <p style={{ 
        color: '#1565c0', 
        margin: '0 0 16px 0',
        fontSize: '14px',
        lineHeight: '1.5'
      }}>
        {featureInfo.benefit}
      </p>
      
      <div style={{ 
        backgroundColor: '#bbdefb', 
        borderRadius: '8px', 
        padding: '12px',
        borderLeft: '4px solid #4361ee'
      }}>
        <h4 style={{ 
          color: '#0d47a1', 
          margin: '0 0 8px 0',
          fontSize: '13px',
          fontWeight: '700',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }}>
          Evidence-Based Research
        </h4>
        <p style={{ 
          color: '#0d47a1', 
          margin: 0,
          fontSize: '13px',
          lineHeight: '1.4'
        }}>
          <strong>{featureInfo.research.stat}</strong> — {featureInfo.research.detail}
        </p>
        <p style={{ 
          color: '#1565c0', 
          margin: '8px 0 0 0',
          fontSize: '12px',
          fontStyle: 'italic',
          lineHeight: '1.4'
        }}>
          {featureInfo.research.backup}
        </p>
      </div>
      
      <div style={{ 
        display: 'flex', 
        justifyContent: 'flex-end', 
        marginTop: '16px' 
      }}>
        <Button 
          onClick={onDismiss}
          size="sm"
          style={{
            backgroundColor: '#4361ee',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            padding: '6px 12px',
            fontSize: '12px',
            fontWeight: '500',
            cursor: 'pointer'
          }}
        >
          Got it
        </Button>
      </div>
    </div>
  );
}

export default EducationalBanner;